export default "__VITE_ASSET__DP2P$WeX__"